import BottomButtons, { BottomButtonsProps } from '../molecules/BottonButtons';
import Header, { HeaderProps } from '@components/atoms/Header';

import { FunctionComponent } from 'react';
import ProgressBar from '@components/atoms/ProgressBar';

interface MainLayoutProps extends BottomButtonsProps, HeaderProps {
  isProgressBarVisible: boolean;
  progress: number;
  children: JSX.Element[] | JSX.Element;
}

const MainLayout: FunctionComponent<MainLayoutProps> = ({
  progress,
  isProgressBarVisible,
  isPassageButtonVisible,
  isNextButtonVisible,
  isReviewButtonVisible,
  isBackButtonVisible,
  isPreviousButtonVisible,
  isAssessTypeButtonVisible,
  minutes = 0,
  seconds = 0,
  isTimerVisible = false,
  isTagVisible = false,
  tag = 'General',
  moduleName = '',
  onClose,
  onShowPasagge,
  onNext,
  onPrevious,
  onAcademic,
  onGeneral,
  onReview,
  children,
}) => {
  return (
    <>
      <div className="flex flex-col h-screen">
        <Header
          minutes={minutes}
          seconds={seconds}
          isTagVisible={isTagVisible}
          tag={tag}
          isTimerVisible={isTimerVisible}
        />
        {isProgressBarVisible ? <ProgressBar progress={progress} /> : ''}
        <div className="flex flex-grow justify-center overflow-y-scroll scrollbar bg-neutral-200">
          {children}
        </div>
        <BottomButtons
          moduleName={moduleName}
          isPassageButtonVisible={isPassageButtonVisible}
          isNextButtonVisible={isNextButtonVisible}
          isBackButtonVisible={isBackButtonVisible}
          isPreviousButtonVisible={isPreviousButtonVisible}
          isReviewButtonVisible={isReviewButtonVisible}
          isAssessTypeButtonVisible={isAssessTypeButtonVisible}
          onNext={onNext}
          onPrevious={onPrevious}
          onShowPasagge={onShowPasagge}
          onClose={onClose}
          onAcademic={onAcademic}
          onGeneral={onGeneral}
          onReview={onReview}
        />
      </div>
    </>
  );
};

export default MainLayout;
